module.exports = __webpack_public_path__ + "static/media/logo-cabify.a5f1ebf8.svg";